import {
  reactQueryPost,
  reactQueryPut,
} from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { ImagePost } from "@circle-react/types";

interface CreateImagePostParams {
  payload: Record<string, unknown>;
  spaceId: number;
}

export const createImagePost = ({ spaceId, payload }: CreateImagePostParams) =>
  reactQueryPost(internalApi.imagePosts.create(spaceId), payload);

interface UpdateImagePostParams {
  payload: Record<string, unknown>;
  postSlug: string;
  spaceId: number;
}

export const updateImagePost = ({
  spaceId,
  postSlug,
  payload,
}: UpdateImagePostParams) =>
  reactQueryPut(internalApi.imagePosts.update(spaceId, postSlug), payload);

interface DuplicateImagePostPayload {
  post: {
    space_id: number;
    send_notifications: boolean;
  };
}

interface DuplicateImagePostParams {
  payload: DuplicateImagePostPayload;
  postSlug: string;
  spaceId: number;
}

export const duplicateImagePost = ({
  spaceId,
  postSlug,
  payload,
}: DuplicateImagePostParams) =>
  reactQueryPut<ImagePost, DuplicateImagePostPayload>(
    internalApi.imagePosts.duplicate(spaceId, postSlug),
    payload,
  );
